import { render, staticRenderFns } from "./DropdownForInserts.vue?vue&type=template&id=407cc31a&scoped=true"
import script from "./DropdownForInserts.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownForInserts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DropdownForInserts.vue?vue&type=style&index=0&id=407cc31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cc31a",
  null
  
)

export default component.exports